import {
  ActionLoggingEventParams,
  ComponentLoggingEventParams,
  SectionLoggingEventParams,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { trackRetailersServerDrivenSlateEvent } from "@faire/web-api--source/events/retailers/actionCategoryOther/serverDrivenSlateEvent";

type SDUIEventType = "VIEW" | "CLICK";

export function logSDUIEvent(
  eventType: SDUIEventType,
  sectionEventParams: SectionLoggingEventParams
): void;
export function logSDUIEvent(
  eventType: SDUIEventType,
  sectionEventParams: ComponentLoggingEventParams
): void;
export function logSDUIEvent(
  eventType: SDUIEventType,
  sectionEventParams: ActionLoggingEventParams
): void;
export function logSDUIEvent(
  eventType: SDUIEventType,
  eventParams: Partial<ActionLoggingEventParams>
): void {
  trackRetailersServerDrivenSlateEvent(
    eventParams.request_id ?? "",
    // view level
    eventParams.view_display_page ?? "",
    eventParams.view_instance_identifier ?? "",
    // section level
    eventParams.section_type ?? "",
    eventParams.section_position?.toString() ?? "",
    // component level
    eventType,
    eventParams.component_name ?? "",
    eventParams.component_instance_identifier ?? "",
    eventParams.component_type ?? "",
    eventParams.component_position?.toString() ?? "",
    // Action level
    eventParams.action_content ?? "",
    eventParams.action_positions ?? "",
    eventParams.action_instance_identifier ?? ""
  );
}
